import React from 'react';
import {Link} from 'react-router-dom';
import logo_fi from '../images/logo_fi.svg';
import logo_sv from '../images/logo_sv.svg';
import logo_fi_lvv from '../images/logo_fi_lvv.svg';
import logo_sv_lvv from '../images/logo_sv_lvv.svg';
import '../styles/header.css';
import {FormattedMessage, useIntl} from 'react-intl';
import LanguageSwitch from './LanguageSwitch';

const Header = props => {
  const intl = useIntl();

  const {headingLevel, title, lvvEnabled} = props;
  const Title = headingLevel;

  return (
    <header className="header">
      <Title style={{display: 'none'}}>{title}</Title>
      <LanguageSwitch language={props.language} onLanguageChange={props.onLanguageChange} />
      <div className="header__nav">
        <div>
          <Link to="/">
            <img
              className={intl.locale === 'fi' ? 'logo__fi' : 'logo__sv'}
              alt={lvvEnabled ? 'lvv-placeholder' : 'Aluehallintovirasto'}
              src={
                lvvEnabled
                  ? intl.locale === 'fi'
                    ? logo_fi_lvv
                    : logo_sv_lvv
                  : intl.locale === 'fi'
                  ? logo_fi
                  : logo_sv
              }
            />
          </Link>
        </div>

        <div className="header__text">
          {lvvEnabled ? (
            <FormattedMessage id="header-header_title-lvv" defaultMessage="lvv-placeholder" />
          ) : (
            <FormattedMessage
              id="header-header_title"
              defaultMessage="Etelä-Suomen aluehallintoviraston ylläpitämä rekisteri perintätoiminnan harjoittajista"
            />
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
